import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'
import { Button } from '@reapit/elements/core/button'

export const FieldStack = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  width: 100%;
`

export const SectionHeading = styled.div`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
  margin-top: 0.5rem;
`

export const FlagsGrid = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`

/** Small helper text shown directly under a field to explain it. */
export const FieldHelp = styled.p`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  line-height: 1.5;
  margin: 0.375rem 0 0;
`

/** Container for the composite-field options editor (a list of label/value rows). */
export const OptionsBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`

/** One option row: label + value inputs side by side, with an optional trailing remove control. */
export const OptionRowLayout = styled.div`
  display: flex;
  align-items: flex-end;
  column-gap: 0.5rem;

  /* The two inputs (label, value) always share the width; the optional remove control stays natural. */
  > *:nth-child(1),
  > *:nth-child(2) {
    flex: 1 1 0;
    min-width: 0;
  }
`

export const OptionRemoveWrap = styled.div`
  flex: 0 0 auto;
  padding-bottom: 0.125rem;
`

/** Clickable heading that expands/collapses a group of fields (Button, styled as a plain disclosure toggle). */
export const CollapsibleToggle = styled(Button)`
  ${font('sm', 'bold')}
  align-self: flex-start;
  justify-content: flex-start !important;
  padding: 0 !important;
  margin-top: 0.5rem;
  color: var(--colour-text-primary, #222b33) !important;

  & svg {
    width: 0.875rem;
    height: 0.875rem;
    flex-shrink: 0;
  }
`
